    <header class="page-head">
      <div>
        <h1 class="page-title">Payment Details</h1>
        <p class="page-subtitle">Add or update your card profile with automatic type detection.</p>
      </div>
      <span class="provider-chip">Detected card: {{ cardType() }}</span>
    </header>

    <section class="detail-grid">
      <div class="detail-card span-7">
        <form class="form-stack" [formGroup]="form">
          <div class="input-group">
            <label for="cardholder">Cardholder name</label>
            <input id="cardholder" formControlName="cardholderName" />
          </div>
          <div class="input-group">
            <label for="number">Card number</label>
            <input id="number" formControlName="cardNumber" placeholder="4111 1111 1111 1111" />
          </div>
          <div class="field-grid">
            <div class="input-group">
              <label for="expiry">Expiry date (MM/YY)</label>
              <input id="expiry" formControlName="expiryDate" placeholder="08/29" />
            </div>
            <div class="input-group">
              <label for="cvv">CVV/CVC/Security code</label>
              <input id="cvv" formControlName="cvv" placeholder="123" />
            </div>
          </div>
          <button class="btn btn-primary" type="button">Save payment details</button>
        </form>
      </div>

      <aside class="detail-card span-5">
        <h2 class="section-title">Detection rules</h2>
        <ul class="simple-list">
          <li>Visa starts with 4</li>
          <li>Mastercard starts with 51-55 or 2221-2720</li>
          <li>Amex starts with 34 or 37</li>
        </ul>
      </aside>
    </section>
